<div class="row container-style">
  <div class="col-lg-6 col-md-6 col-sm-12 col-12 p-1 flex gap-2" *ngFor="let preview of previews; let i = index">
    <p-card [style]="{  overflow: 'hidden' }">
      <ng-template #header>
      </ng-template>
      <ng-template #title> {{ imageTitles[i] }} </ng-template>
      <ng-template #footer>
        <div class="flex gap-4">
          <div *ngIf="preview; else emptySlot">
            <div class="d-flex justify-content-center">
              <p-image [src]="preview" alt="Imagen {{ i + 1 }}" width="150" height="150" />
            </div>
            <div class="d-flex justify-content-end gap-2 mt-2">
              <app-custom-input-image-file [title]="'Reemplazar'" [severity]="'primary'" [icon]="'pi pi-refresh'"
                [variant]="undefined" [label]="'Reemplazar'" [width]="'6.5rem'" [disabled]="disabledForm"
                [idFileName]="'imagen_' + (i + 1) + '_' + (enterpriseContract.enterpriseId)"
                (imgResultAfterResize)="attachImage($event, i + 1)"
                (imgUrl)="attachImageUrl($event, i + 1)"></app-custom-input-image-file>
              <app-custom-button [title]="'Eliminar'" [severity]="'danger'" [icon]="'pi pi-trash'" [label]="'Eliminar'"
                [width]="'5.5rem'" [disabled]="disabledForm" (onClick)="deleteImage(i + 1)"></app-custom-button>

            </div>
          </div>
          <!-- Slot vacío -->
          <ng-template #emptySlot>
            <div class="d-flex justify-content-end gap-2 mt-2">
              <app-custom-input-image-file [title]="'Subir'" [severity]="'primary'" [icon]="'pi pi-upload'"
                [variant]="undefined" [label]="'Subir'" [width]="'5rem'" [disabled]="disabledForm"
                [idFileName]="'imagen_' + (i + 1) + '_' + (enterpriseContract.enterpriseId)"
                (imgResultAfterResize)="attachImage($event, i + 1)"
                (imgUrl)="attachImageUrl($event, i + 1)"></app-custom-input-image-file>
            </div>
          </ng-template>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>